export default __webpack_public_path__ + "static/media/BeVietnam-Italic.83d75e6e.ttf";